
export class GetSaveModelData {
  static readonly type = '[SaveModel] get save model data';

  constructor(public payload: string) {
  }
}
